import { Grid, styled, useMediaQuery } from '@material-ui/core';
import { SdmImage, SdmPaginator, SdmSpacer, SdmTypography } from 'components';
import { useTheme } from '@material-ui/core/styles';
import VisibilityIcon from '@material-ui/icons/Visibility';
import React, { useContext, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { theme } from 'theme';
import translations from 'utils/translations';
import { backHomeLink } from 'utils/constants';
import { useNetwork } from 'services/network';
import { LoaderContext } from 'context/LoaderContextProvider';

const ActionLink = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  cursor: 'pointer',
});

const ExhibitorMap = ({ locale }) => {
  const intl = useIntl();
  const i18n = translations.ExhibitorsList(intl);
  const network = useNetwork();
  const mediaTheme = useTheme();
  const isSmDown = useMediaQuery(mediaTheme.breakpoints.down('sm'));
  const isXsDown = useMediaQuery(mediaTheme.breakpoints.down('xs'));
  const { setLoaderActive } = useContext(LoaderContext);
  const showLoader = () => setLoaderActive(true);
  const hideLoader = () => setLoaderActive(false);

  // States
  const [nextUrl, setNextUrl] = useState();
  const [prevUrl, setPreviousUrl] = useState();
  const [totalPages, setTotalPages] = useState();
  const [hall, setHall] = useState();
  const [activeExhibitors, setActiveExhibitors] = useState([]);

  // Effects
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const _hall = params.get('hall');
    if (!_hall) window.location.href = `${backHomeLink}/${locale}/exhibitors`;
    else {
      setHall(_hall);
      fetchBrands(_hall, false);
    }
  }, []);

  // Functions
  const handleOnView = (e) => {
    window.location.href = `${backHomeLink}/${locale}/exhibitors?salesforce_id=${e.accountId}`;
  };

  const fetchBrands = async (hall, prevUrl, stand = '') => {
    showLoader();
    const parserdHall = ('0' + hall).slice(-2);
    const params =
      prevUrl ||
      `anno=2022&hall=${parserdHall}${
        stand ? `&stand=${stand}` : ''
      }&pageSize=9`;
    const data = await network.exhibitorSearch(params);
    setTotalPages(data.totalPages);
    setNextUrl(data.nextPage?.split('?')?.[1]);
    setPreviousUrl(data.previousPage?.split('?')?.[1]);
    setTotalPages(data.totalPages);
    const withImages = [];
    if (data.data.length) {
      const promises = [];
      data.data.map((e) => promises.push(fetchLogo(e)));
      if (promises.length) {
        const res = await Promise.all(promises);
        res.length &&
          res.map((url, idx) =>
            withImages.push({ ...data.data[idx], brandImage: url || null })
          );
      }
    }
    setActiveExhibitors(withImages.length ? withImages : data.data);
    hideLoader();
  };

  const handlePreviousPage = async () => {
    await fetchBrands(hall, prevUrl);
  };

  const handleNextPage = async () => {
    await fetchBrands(hall, nextUrl);
  };

  const handlePageChange = async ({ page, type }) => {
    const str = `anno=2022&hall=${hall}&pageSize=9&pageNumber=${page}`;
    switch (type) {
      case 'next':
        handleNextPage();
        break;
      case 'previous':
        handlePreviousPage();
        break;
      default:
        await fetchBrands(hall, str);
        break;
    }
  };

  const fetchLogo = async (exhibitor) => {
    if (exhibitor.accountId) {
      const url = await network.getExhibitorLogoUrl(exhibitor?.accountId);
      return url;
    } else {
      return null;
    }
  };

  const fetchNewBrands = () => {
    const inputHall = document.getElementById('brand-internal-pavilion').value;
    const inputStand = document.getElementById('brand-internal-stand').value;
    inputHall && inputStand && fetchBrands(inputHall, false, inputStand);
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <input hidden type="text" id="brand-internal-pavilion" />
        <input hidden type="text" id="brand-internal-stand" />
        <button
          hidden
          id="brand-internal-fetch"
          onClick={() => fetchNewBrands()}
        />
        <div style={{ backgroundColor: '#F3F3F3' }}>
          <SdmSpacer height={50} />
          <SdmTypography
            variant={'h1'}
            style={{ textTransform: 'uppercase' }}
            textAlign="center"
          >
            {i18n.map.title}
          </SdmTypography>
          <SdmSpacer height={50} />
          <div style={{ width: '90%', margin: '0 auto', maxWidth: 1063 }}>
            {activeExhibitors.length > 0 &&
              activeExhibitors.map((e, idx) => (
                <div
                  style={{
                    padding: '16px 30px',
                    backgroundColor: 'white',
                    marginBottom: 20,
                  }}
                  key={idx}
                >
                  <Grid container alignItems="center">
                    <Grid item md={3} sm={4} xs={6}>
                      <SdmImage url={e.brandImage} />
                    </Grid>
                    <Grid item md={6} sm={4} xs={6}>
                      <SdmTypography
                        variant={'h4Regular'}
                        style={{ textTransform: 'uppercase' }}
                      >
                        {e?.nomeEspositore ? ` | ${e?.nomeEspositore}` : ''}
                        {e.nazioneIso3AlphaCode} | {i18n.map.stand} {e.stand} -{' '}
                        {i18n.map.pavillion} {e.hall}
                      </SdmTypography>
                    </Grid>
                    <Grid item md={3} sm={4} xs={12}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: isXsDown ? 'center' : 'flex-end',
                        }}
                      >
                        <ActionLink onClick={() => handleOnView(e)}>
                          <VisibilityIcon
                            style={{
                              color: theme.colors.primary.red,
                              marginRight: 8,
                            }}
                          />
                          <SdmTypography
                            variant={'h4Regular'}
                            margin={0}
                            style={{
                              color: theme.colors.primary.red,
                              marginTop: 3,
                            }}
                          >
                            {i18n.map.view}
                          </SdmTypography>
                        </ActionLink>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              ))}
          </div>
          <Grid
            item
            xs={12}
            style={{
              display: 'flex',
              alignContent: 'center',
              justifyContent: 'space-evenly',
            }}
          >
            {activeExhibitors.length > 0 ? (
              <SdmPaginator
                totalPages={totalPages}
                i18n={i18n.map}
                callBackFunction={handlePageChange}
                isSmDown={isSmDown}
                isXsDown={isXsDown}
              />
            ) : null}
          </Grid>
          <SdmSpacer height={100} />
        </div>
      </Grid>
    </Grid>
  );
};
export default ExhibitorMap;
